// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"398":"0104199a","529":"372b2814","621":"66400619","679":"e8f51efb","772":"ca179d84","942":"9b8d1e0a"}[chunkId] + ".js";
};